/**
 * @desc getBySkuNoPage
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.wms.WarehouseSkuBatchQueryRequestDto,
  params: API.wms.warehouseSkuFacadeImpl.getBySkuNoPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouseSku/getBySkuNoPage`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
